import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import PeopleService from '../../services/hammurabi/people';
import { getPerson } from '../../main/apps/people/store/person';
import { PolicyLinks } from '../../main/apps/people/TermsConsent';

const dismissedKey = (version) => `policy-update-dismissed-${version}`;

const isDismissed = (version) => {
    try {
        return window.localStorage.getItem(dismissedKey(version)) === '1';
    } catch (e) {
        return false;
    }
};

/**
 * "We've updated our Terms and Privacy Policy" for customers who have not accepted the version in force.
 * Accept records the version (and lets Max work on their loans right away); Dismiss only hides the notice.
 */
const PolicyUpdateBanner = () => {
    const person = useSelector(({ entities }) => entities.person.data);
    const dispatch = useDispatch();
    const [terms, setTerms] = useState(null);
    const [hidden, setHidden] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        PeopleService.getCurrentTerms()
            .then(setTerms)
            .catch(() => setTerms(null));
    }, []);

    const version = terms?.terms_version;
    if (!person || !version || person.terms_version === version || hidden || isDismissed(version)) {
        return null;
    }

    const accept = async () => {
        setSaving(true);
        try {
            await PeopleService.acceptTerms(person.id, version);
            dispatch(getPerson(person.id));
            setHidden(true);
            toast.success('Thank you. Your acceptance has been recorded.');
        } catch (e) {
            toast.error('We could not record your acceptance, please try again.');
        }
        setSaving(false);
    };

    const dismiss = () => {
        try {
            window.localStorage.setItem(dismissedKey(version), '1');
        } catch (e) {
            // private mode: hide for this visit only
        }
        setHidden(true);
    };

    return (
        <Alert
            severity="info"
            className="my-4"
            action={
                <>
                    <Button color="primary" size="small" disabled={saving} onClick={accept}>
                        Accept
                    </Button>
                    <Button size="small" onClick={dismiss}>
                        Dismiss
                    </Button>
                </>
            }
        >
            We've updated our Terms and Conditions and our Privacy Policy, including how service providers and
            AI-assisted tools help our team review applications. Please read them: <PolicyLinks terms={terms} />
        </Alert>
    );
};

export default PolicyUpdateBanner;
